import React from 'react';
import { decodeToken, getToken } from '../utils/TokenUtils';
import { API_URL } from '../constants/api';

const PrintTableWithHeader = () => {
  //console.log('local:', localStorage.getItem('printData'));
  const token = getToken();
  const companyLogo = decodeToken(token, 'logo');
  const companyBanner = decodeToken(token, 'banner');

  const companyName = decodeToken(token, 'companyName');

  // Get the jsonData from localStorage
  const storedData = localStorage.getItem('printData');
  //console.log('localstorage:', storedData)

  const parsedData = JSON.parse(storedData); // Parse the JSON string back into an object

  // Destructure title, logo, and tableData if data is available
  const { title, logo, tableData, reportHeader, reportFooter } =
    parsedData || {};

  //console.log(title,logo,tableData)

  const theadData = Object.keys(tableData[0]);

  const styles = {
    printPage: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      border: '1px solid black',
    },
    cell: {
      border: '1px solid black',
      textAlign: 'left',
    },
    header: {
      textAlign: 'center',
      marginBottom: '20px',
    },
    logo: {
      width: '100%',
      height: '150px',
    },
  };

  return (
    <div>
      {/* Header and Table Section */}
      <div style={styles.printPage}>
        <header style={styles.header}>
          <img
            src={`${API_URL}/${companyBanner}`}
            alt="Company Banner"
            style={styles.logo}
          />
        </header>
        <div className="" style={{ paddingLeft: '20px' }}>
          <center>
            <h2>{title}</h2>
          </center>

          {reportHeader &&
            reportHeader.map((item, index) => (
              <div key={index} className="row mb-3">
                {Object.entries(item).map(([key, value], i) => (
                  <div className="col-6 mb-2" key={i}>
                    <strong>{key}:</strong> {value}
                  </div>
                ))}
              </div>
            ))}
        </div>
        <table style={styles.table}>
          <thead>
            <tr>
              {theadData.map((heading) => {
                return (
                  <th style={styles.cell} key={heading}>
                    {heading}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => {
              return (
                <tr key={index}>
                  {theadData.map((key, index) => {
                    return (
                      <td style={styles.cell} key={index}>
                        {row[key]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrintTableWithHeader;
